"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetReserveInfoByIdAndName = void 0;
class GetReserveInfoByIdAndName {
    constructor(httpService) {
        this.getReserveInfoUrl = '/bookings/listByPropNameAndUnitName';
        this.HttpService = httpService;
    }
    run(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.getReserveInfoUrl = `${this.getReserveInfoUrl}?unitName=${params.unitName}&propName=${params.propName}`;
            const response = yield this.HttpService.get(this.getReserveInfoUrl);
            return response;
        });
    }
}
exports.GetReserveInfoByIdAndName = GetReserveInfoByIdAndName;
